module.exports = __webpack_public_path__ + "img/title-5.6c5b903c.png";